import React from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
import { useCart } from '../../contexts/CartContext';
import { useOverlay } from '../../hooks/useOverlay';
import { formatPrice } from '../../utils/currency';
import { easeOut } from '../../utils/motion';
import { btnPrimary, btnSecondary } from '../ui/buttonStyles';
import { CartLineItem } from './CartLineItem';
import { FreeShippingProgress } from './FreeShippingProgress';
export function CartDrawer() {
  const {
    isOpen,
    closeCart,
    lines,
    subtotal,
    count
  } = useCart();
  useOverlay(isOpen, closeCart);
  return <AnimatePresence data-id="element-30" data-mp="22y6zoys9ayfe">
      {isOpen && <>
          <motion.div className="fixed inset-0 z-50 bg-ink/40" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} onClick={closeCart} aria-hidden data-id="element-31" data-mp="22zrtunansfcq" />
          <motion.aside role="dialog" aria-modal="true" aria-label="Votre panier" className="fixed inset-y-0 right-0 z-50 flex w-full max-w-md flex-col bg-paper" initial={{
        x: '100%'
      }} animate={{
        x: 0
      }} exit={{
        x: '100%'
      }} transition={{
        duration: 0.3,
        ease: easeOut
      }} data-id="element-32" data-mp="3fc9ooqkdn8fc">
            <div className="flex h-16 items-center justify-between border-b border-line px-5 md:h-20 md:px-6" data-id="element-33" data-mp="1z6jwzee7rc1">
              <h2 className="font-display text-2xl" data-id="element-34" data-mp="6vwzzmq76mxg">
                Votre panier <span className="text-muted" data-id="element-35" data-mp="3o5uzxzxc27k0">({count})</span>
              </h2>
              <button type="button" autoFocus onClick={closeCart} aria-label="Fermer le panier" className="flex h-10 w-10 items-center justify-center rounded-full hover:bg-shell" data-id="element-36" data-mp="3t4g2w73yz5c5">
                <XIcon className="h-5 w-5" data-id="element-37" data-mp="2hqkkmphrqggp" />
              </button>
            </div>

            {lines.length === 0 ? <div className="flex flex-1 flex-col items-center justify-center px-8 text-center" data-id="element-38" data-mp="j7h7cd9vvxcf">
                <ShoppingBagIcon className="h-8 w-8 text-muted" aria-hidden data-id="element-39" data-mp="egr3j4h3w2ju" />
                <p className="mt-4 font-display text-3xl" data-id="element-40" data-mp="eeo3rsq5iv1x">Votre panier est vide</p>
                <p className="mt-2 text-sm text-muted" data-id="element-41" data-mp="9h4nkn9w887c">
                  Les pièces de la saison ne restent que quelques semaines. C’est le moment de flâner.
                </p>
                <Link to="/boutique" onClick={closeCart} className={`${btnPrimary} mt-6`} data-id="element-42" data-mp="fwpo6bah9ds">
                  Découvrir la boutique
                </Link>
              </div> : <>
                <div className="border-b border-line px-5 py-4 md:px-6" data-id="element-43" data-mp="3mphh9xz02cso">
                  <FreeShippingProgress subtotal={subtotal} data-id="element-44" data-mp="1pw5y61lueibs" />
                </div>
                <ul className="flex-1 divide-y divide-line overflow-y-auto px-5 md:px-6" data-id="element-45" data-mp="1kx2uolligk5x">
                  <AnimatePresence initial={false} data-id="element-46" data-mp="1sgc58i5r6owk">
                    {lines.map(line => <motion.li key={line.key} layout initial={{
                opacity: 0,
                y: 8
              }} animate={{
                opacity: 1,
                y: 0
              }} exit={{
                opacity: 0,
                x: 24
              }} transition={{
                duration: 0.22,
                ease: easeOut
              }} className="py-5" data-id="element-47" data-mp="1xff7juucmh0u">
                        <CartLineItem line={line} onNavigate={closeCart} data-id="element-48" data-mp="1egb20w20n5dx" />
                      </motion.li>)}
                  </AnimatePresence>
                </ul>
                <div className="border-t border-line bg-card px-5 py-5 md:px-6" data-id="element-49" data-mp="1ji0dudx2bn32">
                  <div className="flex items-baseline justify-between" data-id="element-50" data-mp="1ocntroe03961">
                    <span className="text-sm" data-id="element-51" data-mp="2uu18uakis7r9">Sous-total</span>
                    <span className="font-display text-3xl tabular-nums" data-id="element-52" data-mp="2ztnnmofzxw26">{formatPrice(subtotal)}</span>
                  </div>
                  <p className="mt-1 text-xs text-muted" data-id="element-53" data-mp="2xga8niwywlkg">Livraison et codes promo à l’étape suivante. Retrait en boutique gratuit.</p>
                  <div className="mt-4 grid gap-2" data-id="element-54" data-mp="2tfqe8n3s3w20">
                    <Link to="/commande" onClick={closeCart} className={btnPrimary} data-id="element-55" data-mp="37dophjmszcda">
                      Passer commande
                    </Link>
                    <Link to="/panier" onClick={closeCart} className={btnSecondary} data-id="element-56" data-mp="32geuzpkk4ail">
                      Voir le panier
                    </Link>
                  </div>
                </div>
              </>}
          </motion.aside>
        </>}
    </AnimatePresence>;
}